export default [
{
    path: "/procurement-trail/searchProcurement",
        name: "search-procurement",
    meta: { title: "Search Procurements", authRequired: true },
    component: () => import("../views/procurement-trail/searchProcurement.vue"),
},
{
    path: "/procurement-trail/procurementTrail",
        name: "procurement-trail",
    meta: { title: "Procurement Trail", authRequired: true },
    component: () => import("../views/procurement-trail/procurementTrail.vue"),
},
{
    path: "/procurement-trail/viewRequisition",
        name: "view-requisition",
    meta: { title: "View Requisition", authRequired: true },
    component: () => import("../views/procurement-trail/view-requisition.vue"),
},
{
    path: "/procurement-trail/viewTender",
        name: "view-tender",
    meta: { title: "View Tender", authRequired: true },
    component: () => import("../views/procurement-trail/view-tender.vue"),
},
]